import { Suspense, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { SignedIn, SignedOut, SignIn } from "@clerk/clerk-react";
import { LoadingState, ErrorBoundary } from "@/shared/components";
import { useEnvironment } from "@/shared/env";
import { Header } from "./header";

export function AdminLayout() {
  const env = useEnvironment();

  useEffect(() => {
    document.title = env.name === "local" ? "Sonify Admin" : `Sonify Admin [${env.display.label}]`;
  }, [env]);

  const location = useLocation();

  return (
    <>
      <SignedOut>
        <div className="min-h-screen bg-background flex items-center justify-center">
          <SignIn />
        </div>
      </SignedOut>
      <SignedIn>
        <div className="flex flex-col h-screen bg-background">
          <Header />
          <main className="flex-1 flex flex-col min-h-0">
            <ErrorBoundary key={location.pathname}>
              <Suspense fallback={<LoadingState />}>
                <Outlet />
              </Suspense>
            </ErrorBoundary>
          </main>
        </div>
      </SignedIn>
    </>
  );
}
